var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInteractiveVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M101.6 204.8c-28.8 0-50.4 21.6-50.4 50.4v513.6c0 28.8 21.6 50.4 50.4 50.4h614.4c28.8 0 52.8-21.6 52.8-50.4v-180l204 204v-561.6l-204 204v-180c0-28.8-24-50.4-52.8-50.4h-614.4zM162.133 290.133h102.4v102.4h-102.4v-102.4zM332.8 290.133h358.4v51.2h-358.4v-51.2zM332.8 379.733h307.2v51.2h-307.2v-51.2zM162.133 546.129h102.4v102.4h-102.4v-102.4zM332.8 546.133h358.4v51.2h-358.4v-51.2zM332.8 635.733h307.2v51.2h-307.2v-51.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveVideo);
export default __webpack_public_path__ + "static/media/interactive-video.32cb418b.svg";
export { ForwardRef as ReactComponent };